import { SVGProps } from 'react';

export default function Location3(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3348)">
        <path
          d="M10.0002 20C8.81373 20.0029 7.67393 19.5382 6.82766 18.7067L3.54183 15.6708C1.78683 13.9167 0.833496 11.615 0.833496 9.16667C0.833496 6.71833 1.78683 4.41583 3.5185 2.685C5.25016 0.954167 7.55183 0 10.0002 0C12.4485 0 14.7502 0.953333 16.4818 2.685C18.2135 4.41583 19.1668 6.7175 19.1668 9.16667C19.1668 11.6158 18.2135 13.9167 16.4818 15.6483L13.1552 18.7225C12.3116 19.5454 11.1786 20.0041 10.0002 20ZM10.0002 1.66667C9.01484 1.66392 8.03876 1.85665 7.12844 2.23371C6.21811 2.61078 5.39162 3.16467 4.69683 3.86333C3.28016 5.28 2.50016 7.1625 2.50016 9.16667C2.50016 11.1708 3.28016 13.0533 4.69683 14.47L7.97683 17.4992C9.09016 18.5875 10.9285 18.5708 12.0077 17.5158L15.3277 14.4475C16.721 13.0533 17.5002 11.17 17.5002 9.1675C17.5002 7.165 16.7193 5.28083 15.3035 3.86417C14.6086 3.16562 13.7821 2.61179 12.8718 2.23474C11.9615 1.85769 10.9855 1.66406 10.0002 1.66667ZM9.92183 12.0158L14.7493 7.26C14.8273 7.18318 14.8894 7.09175 14.932 6.99093C14.9747 6.89012 14.997 6.78189 14.9978 6.67244C14.9986 6.56298 14.9779 6.45444 14.9368 6.353C14.8956 6.25156 14.8349 6.15922 14.7581 6.08125C14.6813 6.00328 14.5898 5.9412 14.489 5.89856C14.3882 5.85592 14.28 5.83356 14.1705 5.83275C14.0611 5.83194 13.9525 5.85269 13.8511 5.89383C13.7496 5.93496 13.6573 5.99568 13.5793 6.0725L8.7385 10.8233L6.411 8.5675C6.25231 8.41356 6.03897 8.32897 5.81791 8.33233C5.59685 8.33569 5.38618 8.42673 5.23225 8.58542C5.07831 8.7441 4.99372 8.95744 4.99708 9.1785C5.00044 9.39956 5.09148 9.61023 5.25016 9.76417L7.5685 12.0108C7.89433 12.3367 8.321 12.4983 8.7485 12.4983C9.176 12.4983 9.59933 12.3375 9.921 12.015L9.92183 12.0158Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3348">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
